const INTERNAL_KEY = import.meta.env.VITE_INTERNAL_KEY ?? '';

function internalHeaders() {
  return INTERNAL_KEY ? { 'x-internal-key': INTERNAL_KEY } : {};
}

export function analysisPost(url, body, signal, auth = {}) {
  const headers = { 'Content-Type': 'application/json', ...internalHeaders() };
  if (auth.token)  headers['Authorization'] = `Bearer ${auth.token}`;
  if (auth.userId) headers['x-user-id']     = auth.userId;
  return fetch(url, { method: 'POST', headers, body: JSON.stringify(body), signal });
}

export function userWriteHeaders(userId, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token)  headers['Authorization']  = `Bearer ${token}`;
  if (userId) headers['x-user-id']      = userId;
  if (INTERNAL_KEY) headers['x-internal-key'] = INTERNAL_KEY;
  return headers;
}

export function userReadHeaders(userId, token) {
  const headers = {};
  if (token)  headers['Authorization']  = `Bearer ${token}`;
  if (userId) headers['x-user-id']      = userId;
  if (INTERNAL_KEY) headers['x-internal-key'] = INTERNAL_KEY;
  return headers;
}
